import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-a-sales-window',
  templateUrl: './a-sales-window.component.html',
  styleUrls: ['./a-sales-window.component.css']
})
export class ASalesWindowComponent implements OnInit {

  constructor(private titleService: Title) { 
    
  }
  
  ngOnInit(): void {
    this.titleService.setTitle('New Title');
  }

}
